import { IApplicationsStatus } from '@scudraservicos/coordinator-client/dist/src/services/backoffice/interfaces/applications.interface'
import { Box } from 'grommet'
import React, { PureComponent } from 'react'
import { Loading } from '../../../../../legacy-lib/design-kit-ui'
import { CardTitleHeadingStyle, NumberBoxMobileStyle, NumberHeadingStyle, SmallCardStyle, TextStyle } from './style'

interface IApprovedApplicationsCardProps {
  applicationsByStatus?: IApplicationsStatus | Error
}

export default class ApprovedApplicationsCard extends PureComponent<IApprovedApplicationsCardProps> {
  render() {
    const { applicationsByStatus } = this.props

    const approvedApplicationsCardBox =
      applicationsByStatus instanceof Error ? (
        <Box fill align="center" justify="center">
          <TextStyle color="red">{'Não foi possível carregar os dados. Tente novamente.'}</TextStyle>
        </Box>
      ) : (
        applicationsByStatus && (
          <>
            <Box className="desktop" fill justify="between">
              <CardTitleHeadingStyle>Aprovados</CardTitleHeadingStyle>
              <Box>
                <NumberHeadingStyle>
                  {applicationsByStatus.APPROVED > 9
                    ? applicationsByStatus.APPROVED
                    : '0' + applicationsByStatus.APPROVED}
                </NumberHeadingStyle>
                <TextStyle>Clientes aprovados</TextStyle>
              </Box>
            </Box>

            <Box className="is-mobile" fill justify="between">
              <CardTitleHeadingStyle>Aprovados</CardTitleHeadingStyle>
              <NumberBoxMobileStyle align="center">
                <Box margin={{ right: 'medium' }}>
                  <NumberHeadingStyle>
                    {applicationsByStatus.APPROVED > 9
                      ? applicationsByStatus.APPROVED
                      : '0' + applicationsByStatus.APPROVED}
                  </NumberHeadingStyle>
                  <TextStyle>Clientes aprovados</TextStyle>
                </Box>
              </NumberBoxMobileStyle>
            </Box>
          </>
        )
      )
    return (
      <SmallCardStyle>
        {applicationsByStatus ? (
          approvedApplicationsCardBox
        ) : (
          <Box fill align="center" justify="center">
            <Loading />
          </Box>
        )}
      </SmallCardStyle>
    )
  }
}
